import { useLogs } from "@tcomponents/Logs/hooks/useLogs"
import useCurrentLocation from "@thooks/useCurrentLocation"
import CustomTable from "@UI/CustomTable/CustomTable"


const LogsTable = () => {
    const { location } = useCurrentLocation()
    const {
        logsData,
        columns,
        loadingLogsTable,
        handleChangeTable
    } = useLogs({
        format: 'table',
        url: location.state.state.url,
        otherParams: { ...location.state?.state?.logsParams }
    })

    return (
        <div>
            <CustomTable
                className="custom-table-variant-1"
                columns={columns}
                dataSource={logsData?.dataTable}
                loading={loadingLogsTable}
                onChange={handleChangeTable}
                pagination={{
                    pageSize: logsData.metadata.limit,
                    total: logsData.metadata.quantity,
                    defaulPageSize: logsData.metadata.limit,
                    current: logsData.currentPage,
                    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                    position: ["bottomRight"]
                }}
            />
        </div>
    )
}

export default LogsTable
